class NotificationItem {
	constructor(list){
		this._list = list;

		this._id = 0;
		this._user;
		this._type;
		this._created_on;
		this._action_on;
		this._read_on;
		this._entityA;
		this._entityNameA;
		this._entityB;
		this._entityNameB;
		this._item;
		this._itemName;

		this._actions = div('notification-action-row');
	}

	static fromArray(data, list) {
		let inst = new NotificationItem(list);
		inst._id = data.shift();
		inst._user = data.shift();
		inst._type = data.shift();
		inst._created_on = data.shift();
		inst._action_on = data.shift();
		inst._read_on = data.shift();
		inst._entityA = data.shift();
		inst._entityNameA = data.shift();
		inst._entityB = data.shift();
		inst._entityNameB = data.shift();
		inst._item = data.shift();
		inst._itemName = data.shift();

		return inst;
	}

	build(template) {
		if (this._action_on === null) {
			// create actions for the type of notification
			this.actions();
		}
		else if (this._read_on === null) {
			this.toRead();
		}

		this._elem = div('notification-row', [
			p('notification-date', timeAgo(this._created_on)),
			p('notification-message', this.format(template)),
			this._actions
		]);

		return this._elem;
	}

	format(template) {
		template = template.replace(/\{a\}/, this._user === this._entityA ? 'You' : this._entityNameA);
		template = template.replace(/\{b\}/, this._user === this._entityB ? 'You' : this._entityNameB);
		template = template.replace(/\{a_has\}/, this._user === this._entityA ? 'You\'ve' : this._entityNameA + ' has');
		template = template.replace(/\{b_has\}/, this._user === this._entityB ? 'You\'ve' : this._entityNameB + ' has');
		template = template.replace(/\{a\'s\}/, this._user === this._entityA ? 'Your' : this._entityNameA + "'s");
		template = template.replace(/\{a\'s\}/, this._user === this._entityB ? 'Your' : this._entityNameB + "'s");
		template = template.replace(/\{i\}/, this._itemName);
		return template;
	}

	actions(type) {
		switch (this._type) {
			case NOTIFICATION.T_CONNECTION_REQ:
			case NOTIFICATION.GET_SUPPORT_CONNECTION:
			case NOTIFICATION.GIVE_SUPPORT_CONNECTION:
			case NOTIFICATION.SUPERVISION_CONNECTION:
			case NOTIFICATION.T_SUPERVISION_REQ:
			case NOTIFICATION.T_COMMUNITY_INV:
			case NOTIFICATION.T_SHARE_LAYER:
			case NOTIFICATION.T_SHARE_RESOURCES:
			case NOTIFICATION.T_SHARE_GRAPHICS:
			case NOTIFICATION.T_SUBSCRIPTION_ALLOCATION:
			// case NOTIFICATION.T_GOAL_SIDEKICK:
				if (this._list.checkPermission(this._type)) {
					this._actions.appendChild(btn('btn', _('Accept'), {'click': this.action.bind(this, NOTIFICATION.ACCEPT)}));
					this._actions.appendChild(btn('btn', _('Reject'), {'click': this.action.bind(this, NOTIFICATION.REJECT)}));
				}
				break;
			case NOTIFICATION.T_COMMUNITY_REQ:
				if (this._list.checkPermission(this._type)) {
					this._actions.appendChild(btn('btn', _('Contributor'), {'click': this.action.bind(this, NOTIFICATION.CONTRIBUTE)}));
					this._actions.appendChild(btn('btn', _('Associate'), {'click': this.action.bind(this, NOTIFICATION.ASSOCIATE)}));
					this._actions.appendChild(btn('btn', _('Reject'), {'click': this.action.bind(this, NOTIFICATION.REJECT)}));
				}
				break;
		}
	}

	toRead() {
		this._actions.appendChild(btn('btn', _("Mark read"), {'click': this.markRead.bind(this)}));
	}

	action(value) {
		ajg('notification/action', [
			'nId=' + this._id,
			'uId=' + this._user,
			'action=' + value
		], null, this.actionCB.bind(this));
	}

	markRead() {
		ajg('notification/action', [
			'nId=' + this._id,
			'uId=' + this._user
		], null, this.actionCB.bind(this));
	}

	actionCB(reply) {
		if (showError(reply)) return;
		while (this._actions.firstChild) this._actions.removeChild(this._actions.firstChild);
		this._list.showCount(reply.count);
	}

	get id() {return this._id}

	get type() {return this._type}
}